import constate from 'constate';
import { useState } from 'react';

export type AgenticChatViewMode = 'Sidebar' | 'Fullscreen';

/**
 * In-memory, app-wide UI state for the staff app, provided once near the root in `App.tsx`.
 *
 * This is not a dumping ground for state. Each value here must be a small, explicitly scoped piece
 * of UI state that is genuinely needed across distant parts of the app and cannot live in a
 * feature-level context. Current scopes:
 *
 * - `agenticChatViewMode`: whether the Flow AI chat renders as a sidebar or fullscreen.
 *
 * Rules:
 *
 * - Dependencies stay limited to `constate` and React state hooks.
 * - No side effects: no effects, subscriptions, queries, network, routing, or storage access.
 * - No booleans; use declarative string unions so a third state does not need a rename.
 * - Adding a new scope requires review from pod-ui, which owns this file.
 */
function useGlobalState() {
  const [agenticChatViewMode, setAgenticChatViewMode] = useState<AgenticChatViewMode>('Sidebar');

  return { agenticChatViewMode, setAgenticChatViewMode };
}

export const [GlobalStateProvider, useGlobalStateContext] = constate(useGlobalState);
